import React, { useEffect } from 'react';
import LoginFormCard from './components/LoginFormCard';
import Header from 'components/ui/Header';
import Footer from '../landing-page/components/Footer';

const LoginForm = () => {
  useEffect(() => {
    document.title = 'Accedi - Volaptic';
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div
        className="flex-1 flex items-center justify-center px-4 py-10 relative"
        style={{
          backgroundImage: 'url(/assets/images/ChatGPT_Image_May_8__2026__02_38_28_PM-1778244023695.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          paddingTop: 'calc(var(--header-height) + 2.5rem)'
        }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'radial-gradient(ellipse at center, transparent 40%, rgba(255,255,255,0.35) 100%)'
          }}
        />
        <div className="relative z-10 w-full flex justify-center">
          <LoginFormCard />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginForm;